import CreateOutwards from "./CreateOutwards";

export {CreateOutwards}